import { FC, useState } from "react";
import { useOutsideClick } from "../../hooks/useOutsideClick";
import { LanguageCode, useTranslation } from "../../lang/TranslationContext";
import { Box, Flag, Options, Wrapper, Option } from "./selectWithIconStyles";
import { Chevron } from "./styles";
import EN from "../../assets/GBPUSD.png";
import RU from "../../assets/RU.png";
import UA from "../../assets/UA.png";
// import KZ from "../../assets/KZ.png";
// import PL from "../../assets/PL.png";
// import IT from "../../assets/IT.png";
// import AR from "../../assets/AR.png";
// import HI from "../../assets/HI.png";
// import ES from "../../assets/ES.png";
// import ZH from "../../assets/ZH.jpg";
// import JP from "../../assets/USDJPY.png";
// import DE from "../../assets/German.png";

const IMG_MAP = {
  en: EN,
  ua: UA,
  ru: RU,
  // kz: KZ,
  // pl: PL,
  // it: IT,
  // de: DE,
  // jp: JP,
  // ar: AR,
  // hi: HI,
  // zh: ZH,
  // es: ES,
};

type ImgMapKey = keyof typeof IMG_MAP;

export const LANG_OPTIONS = [
  "en",
  "ua",
  "ru",
  // 'kz',
  // 'pl',
  // 'it',
  // 'es',
  // 'de',
  // 'ar',
  // 'hi',
  // 'zh',
  // 'jp',
];

type LanguageSelectProps = {
  smallUi?: boolean;
  optionsPosition?: "top" | "bottom";
};

export const LanguageSelect: FC<LanguageSelectProps> = ({
  smallUi = false,
  optionsPosition = "bottom",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useOutsideClick(() => setIsOpen(false));
  const { language, switchLanguage } = useTranslation();

  return (
    <Wrapper style={{ width: smallUi ? 100 : 115 }} ref={ref}>
      <Box
        small={smallUi}
        style={{ width: smallUi ? 100 : 115 }}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div>
          <Flag>
            <img src={IMG_MAP[language as ImgMapKey]} alt={language} />
          </Flag>
          <p>{language.toUpperCase()}</p>
        </div>
        {isOpen ? (
          <Chevron className="pi pi-chevron-up" />
        ) : (
          <Chevron className="pi pi-chevron-down" />
        )}
      </Box>

      <Options
        showOnTop={optionsPosition === "top"}
        customHeight={138}
        style={{ width: smallUi ? 100 : 115 }}
        $isOpen={isOpen}
      >
        {LANG_OPTIONS.map((option) => (
          <Option
            small={smallUi}
            isSelected={option === language}
            key={option}
            disabled={false}
            onClick={() => {
              switchLanguage(option as LanguageCode);
              setIsOpen(false);
            }}
          >
            <div>
              <Flag>
                <img src={IMG_MAP[option as ImgMapKey]} alt={option} />
              </Flag>
              <p>{option.toUpperCase()}</p>
            </div>
          </Option>
        ))}
      </Options>
    </Wrapper>
  );
};
